export default __webpack_public_path__ + "static/media/equal_icon.70fc88ae.svg";